const routes = [
    {
        name: 'index',
        path: '/',
        component: () => import('@/view/appIndex'),
        meta: {
            title: ' '
        }
    },
    {
        name: 'login',
        path: '/login/login',
        component: () => import('@/view/login/login'),
        meta: {
            title: '登录'
        }
    },
    {
        name: 'register',
        path: '/login/register',
        component: () => import('@/view/login/register'),
        meta: {
            title: '注册'
        }
    },
    {
        name: 'forget',
        path: '/login/forget',
        component: () => import('@/view/login/forget'),
        meta: {
            title: '忘记密码'
        }
    }
];

export default routes
